export default __webpack_public_path__ + "media/project.8c405ade.jpg";